<template>
  <main role="main" class="container py-5">
    <h4>Test v-select</h4>

    <b-form @submit.prevent="submitForm">
      <b-form-group label="Text input 1">
        <b-form-input type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Khách mời tham gia" label-for="input-name">
        <v-select class="vs-normalizer" label="name" v-model="selected"
                  :clearable="false"
                  :filterable="false"
                  :options="selectOptions"
                  :clearSearchOnBlur="() => false"
                  :clearSearchOnSelect="false"
                  @search="doSearchDebounced" v-on:option:selecting="onSelecting">
          <template v-slot:search="{attributes, events}">
            <input id="input-name" v-bind="attributes" v-on="events" v-model="inputValue"
                   class="form-control" required minlength="2" maxlength="100"/>
          </template>
          <template v-slot:option="option">
            {{ option.name }} - {{ option.email }}
          </template>
        </v-select>
      </b-form-group>

      <div class="text-monospace" style="white-space: pre; font-size: 14px;">{{ selectedValueText }}</div>

      <b-button type="submit" variant="primary">Submit</b-button>

    </b-form>

  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  import * as contactService from "@/service/contactService";
  import * as util from "@/service/util";


  @Component
  export default class TestTypeahead extends BaseComponent {

    selectOptions = [];
    selected = null;
    inputValue = "";

    doSearchDebounced: Function = null;

    mounted() {
      this.doSearchDebounced = _.debounce(async (q: string, loading: (p: boolean) => void) => {
        try {
          if (q.length < 2) {
            this.selectOptions = [];
          } else {
            loading(true);
            this.selectOptions = (await contactService.getAllContacts(1, 100, q)).data;
          }

        } catch (e) {
          this.toastError(e);

        } finally {
          loading(false);
        }
      }, 300);
    }

    onSelecting(option) {
      this.inputValue = option.name;
      util.clearCustomValidity();
    }

    get selectedValueText(): string {
      return JSON.stringify(this.selected, null, 4);
    }

    submitForm() {

    }

  }
</script>
